import React from 'react';
import classnames from 'classnames';
import { history } from 'umi';
import COSDocPreviewer, { NavigatorToolbar } from '@gp/components/COSDocPreviewer';
import CommonNoAuthPageAccess from './CommonNoAuthPageAccess';
import { getBIDSTencentQCouldMassage } from '@sg/services/cos';
import { ENV } from '@home/_config/config';
import type { IBaseProps } from '@home/types/common';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { STRATEGIC_STORAGE_KEY } from '@sg/constants/storageKeys';
import { buildLiveTitlesUrl } from '@sg/pages/StudioManagement/LiveTitles/utils/liveTitlesUrl';

interface ILiveTitlesDocPreviewerProps extends IBaseProps {
  // 预览文档的cos的存储的key
  doc_key: string;
  doc_name?: string;
  doc_suffix?: string;
  game_title?: string; // Game title for navigation back to Live Titles page
  studio_id?: string | number; // Legacy fallback for old links
  cos_domain?: string; // COS config domain from URL params
//   scroll_target?: 'notes'; // Which section to scroll to after navigating back
}

// Require login to view documents (ensures watermark is always applied)
const getAuth = async (): Promise<boolean> => {
  const userName = sessionStorage.getItem('userName');
  // Only allow access if user is logged in (has userName)
  return !!userName;
};

const LiveTitlesDocPreviewer: React.FC<ILiveTitlesDocPreviewerProps> = (props) => {
  const {
    style,
    className,
    doc_key: docKey,
    doc_name: docName = '',
    doc_suffix: docSuffix = '',
    game_title: gameTitle,
    studio_id: studioId,
    cos_domain: cosDomain,
    // scroll_target: scrollTarget = 'notes',
  } = props;

  const handleNavigatorClick = () => {
    // Store scroll indicator in sessionStorage if returning to notes
    // if (studioId && scrollTarget === 'notes') {
    //   storage.setSessionStorageItem(STRATEGIC_STORAGE_KEY.LIVE_TITLES_NOTES_ID, 'true');
    // }
    
    // Navigate back with game_title in URL (studio_id kept as fallback for legacy links).
    const selectedKey = gameTitle || (studioId !== undefined ? String(studioId) : '');
    history.replace(
      buildLiveTitlesUrl({
        liveView: 'business',
        gameTitle: selectedKey || 'all',
      }),
    );
  };

  // 全球加速，预发布和正式
  const controlledEnv = ['pre', 'pro'];
  const isUseAccelerate = controlledEnv.includes(ENV);

  // Path for this previewer type
  const cosPath = cosDomain || 'mgmt/studio/live_titles/notes';

  return (
    <div style={style} className={classnames('dbs-live-titles-doc-previewer', className)}>
      <COSDocPreviewer
        docKey={docKey}
        docName={docName}
        docSuffix={docSuffix}
        cosOptions={{
          useAccelerate: isUseAccelerate,
          baseCOSConfigFetcher: () => getBIDSTencentQCouldMassage(cosPath),
          authorizationFetcher: (_options?: any) => getBIDSTencentQCouldMassage(cosPath),
        }}
        getAuthParams={{}}
        getAuth={getAuth}
        toolbar={<NavigatorToolbar title="Back to Live Titles" onNavigatorClick={handleNavigatorClick} />}
        noAuth={<CommonNoAuthPageAccess />}
      />
    </div>
  );
};

export default LiveTitlesDocPreviewer;
